export class Feature {
    featureTitle: string;
    featureAmount: string;

    constructor(feature: any) {
        this.featureTitle = feature.featureTitle;
        this.featureAmount = feature.featureAmount;
    }
}